import { Component } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { PAGE_NAME } from 'globals/store/permissions.data';
import { filterActions, filterPageTypes } from '../../store/filters.era';
import { LogisticsShareable } from 'globals/store/share.data';
import { LogisticsShareTableData } from '../../helpers/table-column-types';
import { JoiEvent } from 'globals/store/events.data';
import { Subject } from 'rxjs';
import { accountEventStates } from '../../store/reselectors/null.reselector';
import { FiltersDialogComponent } from '../../components/filters/filters-dialog.component';
import { FilterDialogComponentParams } from '../../components/filters/filters-ui.models';
import { NestedChecksDialogData, NestedChecksReturnData, NestedChecksDialogComponent } from '../../components/wizards/nested-checks.dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { AllSameKeysToTypeEnforcer, generateEmailLink } from '../../helpers/helpers';
import { programLogsticsDisplayOptionsNestedFieldCheckGroups, logisticsViewOptions } from '../program/program.logistics.display-options';
import { BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { ShareOSSDotMenuChoices, allDefaultLogisticsShareColumns, logisticsShareTableColumnsById } from '../../helpers/table-helpers';
import { TableColumn, TableMenuItem, TableDotMenuItem } from '../../helpers/table.data';
import { logisticsShareReselector } from '../../store/reselectors/onsite.share.reselector';
import { filteredLogisticsShareReselector } from '../../store/reselectors/programs.reselector';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { FullLogisticsShareData, LogisticsShareData } from 'globals/store/logistics.data';
import { compactDate, jsonCopyObject, str2Date } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { NestedTableComponent } from 'src/app/components/nested-table/nested-table.component';
import { ShareCodeComponent } from '../share/share-code.component';
import { BlackBarWrapperComponent } from 'src/app/components/wrappers/black-bar-wrapper.component';
import { TrafficLightComponent } from 'src/app/components/misc/traffic-light.component';
import { EnableLinksComponent } from './enable-links-component';
import { LogisticsShareView } from './logistics-share-view.component';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { AbnormalStateComponent } from '../dashboard/abnormal_state.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'logistics-share-app',
    templateUrl: './logistics-share-app.html',
    styleUrls: ['../../page.scss', '../onsiteschedule/onsite.share.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, LoaderComponent, IconTextComponent, AbnormalStateComponent, TopMenuComponent, MobileMenuComponent, LoaderPaneFragmentComponent, CommandMenuComponent, NestedTableComponent, CommonModule, ShareCodeComponent, BlackBarWrapperComponent, TrafficLightComponent, EnableLinksComponent, LogisticsShareView],
})
export class LogisticsShareAppComponent extends Wrapper<LogisticsShareAppComponent> {
  processing: boolean
  page_name = PAGE_NAME.logistics_share
  traceNames = traceNames
  searchTerm = ''
  filterPage = filterPageTypes.programLogistics // ONLY used for search term, which isn't used in views

  fullShareData: FullLogisticsShareData
  event: JoiEvent
  shareCode: string
  private $selectShareable: Subject<boolean> = new Subject()
  nullState = accountEventStates.logisticsNotShared
  nullTitle = 'Share a production view'
  SHARED_MESSAGE = 'Below is what your audience will see when they visit the shareable webpage.'
  UNSHARED_MESSAGE = 'Below is a preview of the shareable webpage.'

  shareList: LogisticsShareTableData[] = []
  shareTableRowsById: { [id:string]: LogisticsShareTableData } = {}
  columnData: TableColumn[] = allDefaultLogisticsShareColumns
  columnsById: { [id: string]: TableColumn } = logisticsShareTableColumnsById
  singleSelectionMenuItems: TableMenuItem[] = [
    { title: 'Edit', method: this.editShareView.bind(this) },
    { title: 'Duplicate', method: this.duplicateShareView.bind(this) },
  ]
  multiSelectionMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteShareViews.bind(this) }
  ]
  menuItems: TableMenuItem[] = []
  dotMenuItems: AllSameKeysToTypeEnforcer<ShareOSSDotMenuChoices, TableDotMenuItem> = {
    view: { id: 'view', title: 'View', method: this.openShareView.bind(this) },
    edit: { id: 'edit', title: 'Edit', method: this.editSingleShareView.bind(this) },
    delete: { id: 'delete', title: 'Delete', method: this.deleteSingleShareView.bind(this) },
    duplicate: { id: 'duplicate', title: 'Duplicate', method: this.duplicateSingleShareView.bind(this) },
  }
  defaultColumnId = 'name'
  brandingData: BrandingData
  selectedShare: LogisticsShareable

  constructor() {
    super()
    const brandingSelectData: BrandingSelectData = {
      type: 'forms',
      brandFormType: 'logistics'
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subCallback(this.store.select(logisticsShareReselector), ({ shareTableData, shareTableRowsById }) => {
      // console.log({ shareTableData })
      this.shareList = shareTableData
      this.shareTableRowsById = shareTableRowsById
    })
  }

  openGreenInputDialog(title: string, header: string, placeholder: string, successLabel: string, currentValue: string = null, emptyOK = false, secondValue: string = null, secondPlaceholder: string = null) {
    return this.openInputDialog(this.uiService.labelsByType.event.color, title, header, placeholder, successLabel, currentValue, emptyOK, secondValue, secondPlaceholder)
  }

  duplicateSingleShareView({ shareInfo }: LogisticsShareTableData) {
    this.openGreenInputDialog('Duplicate Production View', `Duplicate ${shareInfo.title} to a new production view`, 'Production view name', 'DUPLICATE', `${shareInfo.title} copy`).then(result => result && this.logisticsShareService.duplicateLogisticsShareable(shareInfo, result.values[0]))
  }

  duplicateShareView(shareTableData: LogisticsShareTableData[]) {
    this.duplicateSingleShareView(shareTableData[0])
  }

  emailGenerator(publishCode: string) {
    const firstDate = this.event.first_date
    const dateText = firstDate ? `, ${compactDate(str2Date(firstDate))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information for ${title}${dateText}`
    const body = `Hi there,\n\nPlease click on the link below to view details on ${title}${dateText}.\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }

  editSingleShareView({ shareInfo }: LogisticsShareTableData) {
    this.openGreenInputDialog('Production View Name and Description', 'Update your production view name and description', 'Production view name', 'UPDATE', shareInfo.title, false, shareInfo.description, 'Production view description').then(result => result && this.logisticsShareService.updateLogisticsShareable(shareInfo.code, { title: result.values[0] || '', description: result.values[1] || '' }))
  }

  editShareView(shareTableData: LogisticsShareTableData[]) {
    this.editSingleShareView(shareTableData[0])
  }

  deleteSingleShareView(shareTableItem: LogisticsShareTableData, event) {
    this.deleteShareViews([shareTableItem], event)
  }

  async deleteShareViews(shareTableData: LogisticsShareTableData[], event) {
    const n = shareTableData.length
    const data: ConfirmDeleteData = {
      title: `Delete Logistic View${n === 1 ? '' : 's'}`,
      para: `Are you sure you want to delete ${n === 1 ? 'this' : 'these ' + n} logistic view${ n === 1 ? '' : 's'}?  This action cannot be undone`,
      rect: event.target.getBoundingClientRect(),
      deleteButtonText: 'DELETE',
      dialog: this.dialog
    }
    
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    this.logisticsShareService.deleteLogisticsShareables(shareTableData.map(t => t.shareInfo.code))

  }

  ngOnDestroy() {
    this.$selectShareable.next(true); this.$selectShareable.complete();
  }

  openShareView(shareItem: LogisticsShareTableData) {
    const { shareInfo } = shareItem
    const { filters, code } = shareInfo
    if (filters) this.store.dispatch(filterActions.updateFilters({ filterGroup: filterPageTypes.programLogistics, filters }))
    this.shareCode = code
    this.subProp(this.store.select('shareables', 'logistics', code), 'selectedShare', this.$selectShareable)
    this.selectProp(filteredLogisticsShareReselector, { code }, 'fullShareData', this.$selectShareable)
  }

  closeShareView() {

    this.$selectShareable.next(true)
    this.shareCode = null;
    this.selectedShare = null;
  }

  addShare() {
    this.openGreenInputDialog('Add a Production View', 'Give your new production view a name and description', 'Production view name', 'ADD', null, false, '', 'Production view description').then(result => result && this.logisticsShareService.createLogisticsShareable(result.values[0], result.values[1]))
  }

  async share() {
    await this.logisticsShareService.updateLogisticsShareable(this.selectedShare.code, { status: 'shared' })
  }

  async unshare() {
    await this.logisticsShareService.updateLogisticsShareable(this.selectedShare.code, { status: 'unshared' })
  }

  async toggleEnableLinks() {
    await this.logisticsShareService.updateLogisticsShareable(this.selectedShare.code, { noURLs: !this.selectedShare.noURLs })
  }

  selectIds(ids: Set<string>) {
    setTimeout(() => {
      this.menuItems = ids.size === 1 ? [...this.singleSelectionMenuItems, ...this.multiSelectionMenuItems] : [...this.multiSelectionMenuItems]
    }, 0)
  }

  async editDisplayOptions() {
    const nestedCheckGroups = jsonCopyObject(programLogsticsDisplayOptionsNestedFieldCheckGroups)
    const data: NestedChecksDialogData = {
      title: 'Display options',
      successLabel: 'SAVE',
      deselectedIds: [...this.selectedShare.excludedFieldIds],
      backgroundColor: this.uiService.labelsByType.event.color,
      nestedCheckGroups,
      views: logisticsViewOptions
    }
    console.log({ data, nestedCheckGroups })
    const result = await openDialogGetResult<NestedChecksReturnData>(this.dialog, NestedChecksDialogComponent, { width: '480px', disableClose: true, data })

    if (!result) return
    await this.logisticsShareService.updateLogisticsShareable(this.selectedShare.code, { excludedFieldIds: result.deselectedIds })
  }

  async openFilters() {
    const filterGroupings = await this.filtersService.buildProgramLogisticsFilterUI()
    const params: FilterDialogComponentParams = { width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.programLogistics, filterGroupings }}
    const filtersChanged = await this.openDialogGetResult(FiltersDialogComponent, params);
    if (filtersChanged) await this.logisticsShareService.updateOpenFilters(this.selectedShare.code)
  }


}